// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-input_icon__9fBby {
  width: 20px;
  height: 20px;
  color: var(--mui-palette-primary-500);
}

.search-input_input__NsS3B {
  padding-left: 8px !important;
}`, "",{"version":3,"sources":["webpack://./../../packages/ui/dist/input/search-input.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,4BAA4B;AAC9B","sourcesContent":[".icon {\n  width: 20px;\n  height: 20px;\n  color: var(--mui-palette-primary-500);\n}\n\n.input {\n  padding-left: 8px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `search-input_icon__9fBby`,
	"input": `search-input_input__NsS3B`
};
export default ___CSS_LOADER_EXPORT___;
